import { create } from "zustand";

interface ModalState {
   isRemoveUSPModalOpen: boolean;
   openRemoveUSPModal: () => void;
   closeRemoveUSPModal: () => void;
}

export const useRemoveUSPModalStore = create<ModalState>((set) => ({
   isRemoveUSPModalOpen: false,
   openRemoveUSPModal: () => set({ isRemoveUSPModalOpen: true }),
   closeRemoveUSPModal: () => set({ isRemoveUSPModalOpen: false }),
}));
